import { styled } from '@mui/system'
import Button from './../../button'

const Root = styled('div')`
	height: 100%;
	.MuiCard-root {
		.MuiCardContent-root {
			height: 100%;
			padding: 20px 32px;
			> .MuiGrid-container {
				height: 100%;
			}
			${({ theme }) => theme.breakpoints.up('sm')} {
				padding: 30px 60px;
			}
			.icon-pin {
				position: absolute;
				left: -40px;
				top: -3px;
			}
		}
	}
`
const GetDirection = styled(Button)`
	margin-top: ${({ theme }) => theme.spacing(2)};
`

export { Root, GetDirection }
